import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Sparkles, Award, BookOpen, Users, Shield, ArrowRight, Leaf } from 'lucide-react';

const VitalHealthAssociationPage = () => (
  <div style={{ minHeight: '100vh', background: '#0f172a', color: '#e2e8f0' }}>
    <div style={{ padding: '20px 40px', display: 'flex', gap: 20, alignItems: 'center' }}>
      <Link to="/" style={{ display: 'inline-flex', gap: 8, color: '#cbd5e1', textDecoration: 'none' }}>
        <ArrowLeft size={18} /> Back to Home
      </Link>
      <Link to="/association" style={{ marginLeft: 'auto', color: '#d8b4fe', textDecoration: 'none' }}>
        ← View combined association &amp; join
      </Link>
    </div>

    <section style={{ padding: '40px 40px 60px', maxWidth: 1000, margin: '0 auto', textAlign: 'center' }}>
      <div style={{ width: 80, height: 80, borderRadius: 20, background: '#f3e8ff', color: '#9333ea', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 18px' }}>
        <Sparkles size={42} />
      </div>
      <div style={{ display: 'inline-block', padding: '6px 14px', borderRadius: 999, background: 'rgba(147,51,234,0.18)', color: '#d8b4fe', fontSize: '0.72rem', letterSpacing: 1.2, textTransform: 'uppercase', marginBottom: 14 }}>
        Division of the MedCare Association
      </div>
      <h1 data-testid="vital-health-title" style={{ fontSize: '2.5rem', fontWeight: 800, color: '#f8fafc', margin: 0, lineHeight: 1.18 }}>
        Vital Health Sciences Association
      </h1>
      <p style={{ color: '#cbd5e1', maxWidth: 720, margin: '20px auto 0', lineHeight: 1.65, fontSize: '1.05rem' }}>
        A non-licensed credentialing body for integrative, holistic, herbal, and
        natural-health practitioners — backing the five MedCare doctorate programs
        (Doctor of Natural Health, Doctor of Holistic Wellness, Herbal Health
        Practitioner, Integrative Wellness Consultant, and Doctor of Vital Health
        Sciences — Practitioner).
      </p>
    </section>

    <section style={{ padding: '40px 40px', maxWidth: 1000, margin: '0 auto' }}>
      <h2 style={{ fontSize: '1.5rem', color: '#f8fafc' }}>About us</h2>
      <p style={{ color: '#cbd5e1', lineHeight: 1.7 }}>
        The Vital Health Sciences Association was created so that graduates of
        non-licensed integrative and holistic doctorate programs would have a
        clear, ethics-first community to belong to — one that explicitly states
        what they <strong>can</strong> and <strong>cannot</strong> do in practice.
        We support evidence-aware, scope-honest wellness practice that complements
        (never replaces) licensed care teams.
      </p>
      <p style={{ color: '#cbd5e1', lineHeight: 1.7, marginTop: 16 }}>
        Every member of the Association agrees to a written Code of Ethics covering
        informed consent, truthful marketing (no diagnose/treat/cure claims unless
        FDA-approved), professional-liability insurance, mandatory referral to
        licensed care for red-flag symptoms, and documentation of every
        consultation.
      </p>

      <h2 style={{ fontSize: '1.5rem', color: '#f8fafc', marginTop: 36 }}>Mission statement</h2>
      <p style={{ color: '#cbd5e1', lineHeight: 1.7, fontStyle: 'italic' }}>
        &ldquo;To champion an ethics-first, scope-honest practice of integrative and
        holistic wellness — protecting the public, supporting our members, and
        building bridges to licensed care wherever the client&apos;s well-being
        demands it.&rdquo;
      </p>
    </section>

    <section style={{ padding: '40px 40px', maxWidth: 1000, margin: '0 auto' }}>
      <h2 style={{ fontSize: '1.5rem', color: '#f8fafc' }}>What we stand for</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 18, marginTop: 16 }}>
        {[
          { icon: Award, t: 'Doctorate Credentialing', d: 'Register graduates of the 5 MedCare doctorate tracks.' },
          { icon: BookOpen, t: 'Continuing Education', d: 'Track CE hours across nutrition, mind-body, herbal, and lifestyle medicine.' },
          { icon: Users, t: 'Public Directory', d: 'Searchable, verifiable directory of association members.' },
          { icon: Shield, t: 'Code of Ethics', d: 'Mandatory written ethics agreement signed by every member.' },
          { icon: Leaf, t: 'Sustainability', d: 'Endorse ethical sourcing of herbs and respect for traditional knowledge.' },
        ].map((b) => {
          const I = b.icon;
          return (
            <div key={b.t} style={{ background: 'rgba(255,255,255,0.04)', padding: 18, borderRadius: 12, border: '1px solid rgba(255,255,255,0.06)' }}>
              <I size={22} color="#d8b4fe" />
              <div style={{ color: '#f8fafc', fontWeight: 700, marginTop: 8 }}>{b.t}</div>
              <p style={{ color: '#94a3b8', marginTop: 4, lineHeight: 1.55, fontSize: '0.92rem' }}>{b.d}</p>
            </div>
          );
        })}
      </div>
    </section>

    <section style={{ padding: '0 40px 80px', maxWidth: 1000, margin: '0 auto', textAlign: 'center', marginTop: 30 }}>
      <Link to="/association" data-testid="vital-health-join-link" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, padding: '16px 36px', borderRadius: 999, background: 'linear-gradient(90deg,#a78bfa,#9333ea)', color: 'white', fontWeight: 700, textDecoration: 'none', fontSize: '1rem' }}>
        Become a Member — $9.99/month <ArrowRight size={20} />
      </Link>
      <p style={{ marginTop: 12, fontSize: '0.85rem', color: '#94a3b8' }}>
        One membership covers both the Vital Health Sciences and the MedCare Board of Nursing divisions.
      </p>
    </section>
    <div style={{ padding: '24px 40px', textAlign: 'center', color: '#64748b', fontSize: '0.85rem' }}>
      MedCare Nursing Institute &amp; Training Academy · 3150 E. Shelby Dr, Memphis TN 38118 · 901.625.1201
    </div>
  </div>
);

export default VitalHealthAssociationPage;
